import map from "lodash-es/map";
import replace from "lodash-es/replace";
import { getAvailabilityLabel } from "src/services/mapperService";

import { stringify } from "../../../../lib/utils/text";
import { IAlgoliaProduct, IProduct } from "../../../../types/product";

const transformStarsStringToFloat = (stars: string): number | null => {
  let updatedStars = replace(stars, /&#9734;/g, "☆");
  updatedStars = replace(updatedStars, /&#9733;/g, "★");

  switch (updatedStars) {
    case "☆☆☆☆☆":
      return 0;
    case "★☆☆☆☆":
      return 1;
    case "★★☆☆☆":
      return 2;
    case "★★★☆☆":
      return 3;
    case "★★★★☆":
      return 4;
    case "★★★★★":
      return 5;
    default:
      return null;
  }
};

/**
 * Convert valid string/number/boolean (1, oui, yes, true) into true
 * @param str
 */
export const attrToBool = (val?: string | number | boolean | null): boolean =>
  typeof val === "string"
    ? ["1", "oui", "yes", "true"].includes(val.toLowerCase())
    : typeof val === "number"
    ? val === 1
    : typeof val === "boolean"
    ? val
    : false;

export const mapAlgoliaProducts = (
  algoliaProducts: IAlgoliaProduct[]
): IProduct[] =>
  map(
    algoliaProducts,
    (algoliaProduct: IAlgoliaProduct): IProduct => {
      const redirectUrl = /http[s]?:\/\/[^/]*(\/.*)/.exec(algoliaProduct.url);

      const price = algoliaProduct.price.EUR.default;
      const actualPrice = typeof price === "string" ? parseFloat(price) : price;

      let originalPrice = actualPrice;
      if (algoliaProduct.price.EUR.default_original_formated) {
        originalPrice = parseFloat(
          algoliaProduct.price.EUR.default_original_formated
            .replace("€", "")
            .replace(",", ".")
        );
      }

      return {
        __typename: "Product",
        activationDate: algoliaProduct.activation_date,
        activationDateTimestamp:
          algoliaProduct.activation_date_timestamp * 1000,
        actualPrice,
        brand: {
          id: algoliaProduct.brand,
          name: algoliaProduct.brand,
        },
        categories: algoliaProduct.categories,
        displayPrice: attrToBool(algoliaProduct.display_price),
        id: algoliaProduct.objectID
          ? algoliaProduct.objectID.toString().replace(/ /g, "")
          : "",
        image: algoliaProduct.image_url,
        isNew: algoliaProduct.is_new,
        isTopVente: algoliaProduct.is_top_vente,
        isIncontournable: algoliaProduct.is_incontournable,
        isDispoWhiskyLive: attrToBool(algoliaProduct.dispo_whisky_live),
        name: algoliaProduct.name,
        originalPrice,
        originCountry: stringify(algoliaProduct.origin_country),
        outOfStock: !algoliaProduct.in_stock,
        promotion: algoliaProduct.promotion,
        productFamily: stringify(algoliaProduct.product_family),
        productSubFamily: stringify(algoliaProduct.product_type),
        reference: stringify(algoliaProduct.sku),
        rewards:
          algoliaProduct.awards && typeof algoliaProduct.awards === "string"
            ? [algoliaProduct.awards]
            : undefined,
        shortDescription: algoliaProduct.short_description,
        sku: stringify(algoliaProduct.sku),
        stars: transformStarsStringToFloat(algoliaProduct.rating),
        strength: algoliaProduct.strenght,
        url: redirectUrl && redirectUrl.length > 1 ? redirectUrl[1] : "",
        volume: algoliaProduct.volume,
        presale:
          algoliaProduct.presale === "Non" || algoliaProduct.presale === "No"
            ? null
            : algoliaProduct.presale,
        presaleShippingDate: stringify(algoliaProduct.presale_shipping_date, {
          strategy: "first",
        }),
        availabilityLabel: getAvailabilityLabel(
          algoliaProduct.availability_label_new
        ),
      };
    }
  );
